import React from "react";
import type { UploadResult, SkippedFile } from "../types";
import { XMarkIcon } from "@heroicons/react/20/solid";

interface UploadResultsProps {
  uploaded: UploadResult[];
  skipped: SkippedFile[];
  onDismiss?: () => void;
}

export function UploadResults({
  uploaded,
  skipped,
  onDismiss,
}: UploadResultsProps) {
  const hasContent = uploaded.length > 0 || skipped.length > 0;
  if (!hasContent) return null;

  return (
    <div className="flex items-start rounded-md border border-border bg-muted px-3 py-2 text-sm text-foreground shadow-lg mb-6">
      <div className="flex-1">
        {uploaded.length > 0 && (
          <p className="font-medium mb-1">
            Uploaded ({uploaded.length}):{" "}
            {uploaded.map((u) => u.filename).join(", ")}
          </p>
        )}
        {skipped.length > 0 && (
          <p className="text-sm">
            Skipped ({skipped.length}):{" "}
            {skipped.map((s) => `${s.filename} (${s.reason})`).join("; ")}
          </p>
        )}
      </div>
      {onDismiss && (
        <button
          type="button"
          className="inline-flex items-center justify-center rounded-full h-8 w-8 p-0 text-foreground hover:bg-accent disabled:opacity-50"
          onClick={onDismiss}
          aria-label="Dismiss"
        >
          <XMarkIcon className="w-5 h-5" />
        </button>
      )}
    </div>
  );
}
